import { Heart, Bird, Tag, Sparkle, Rocket } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

interface CouponCodeProps {
  code: string;
  className?: string;
  amount?: number; // Percentage off, default to 10%
}

// Map coupon codes to specific icons
const getCouponIcon = (code: string) => {
  if (code === "Teacher Tools - Free") {
    return <Heart size={24} weight="fill" />;
  }
  if (code === "Teacher Tools - Early Bird") {
    return <Bird size={24} weight="fill" />;
  }
  if (code === "Launch benefit" || code.toLowerCase().includes("launch")) {
    return <Rocket size={24} weight="fill" />;
  }

  return <Tag size={24} weight="fill" />;
};

function CouponCode({ code, className, amount }: CouponCodeProps) {
  const icon = getCouponIcon(code);

  return (
    <div className={cn("relative w-fit", className)}>
      <div className="absolute w-full h-full transform rounded-lg top-2 left-2 bg-black/20 rotate-1" />

      <div className="relative p-4 transition-transform duration-300 transform border-2 border-yellow-300 rounded-lg shadow-lg bg-gradient-to-br from-yellow-50 to-yellow-100 -rotate-1 hover:rotate-0">
        <div className="absolute top-0 bottom-0 w-2 left-1">
          <div className="flex flex-col h-full justify-evenly">
            {Array.from({ length: 12 }).map((_, i) => (
              <div
                key={i}
                className="w-2 h-2 bg-white rounded-full shadow-inner shadow-black/20 "
              />
            ))}
          </div>
        </div>
        <div className="absolute top-0 bottom-0 w-2 -right-1">
          <div className="flex flex-col h-full justify-evenly">
            {Array.from({ length: 12 }).map((_, i) => (
              <div key={i} className="w-2 h-2 bg-yellow-100 rounded-full" />
            ))}
          </div>
        </div>

        <div className="flex items-center gap-3 px-2">
          <div className="text-yellow-700">{icon}</div>
          <div className="flex flex-col font-mono">
            <span className="text-xs font-semibold tracking-wide text-yellow-600 uppercase">
              Coupon Applied
            </span>
            <span className="text-lg font-bold tracking-wider text-yellow-800">
              {code}
            </span>
            <span className="font-mono tracking-widest text-yellow-800">
              {amount}% off!
            </span>
          </div>
        </div>

        <div className="absolute top-1 right-4">
          <Sparkle size={12} weight="fill" className="text-yellow-400" />
        </div>
        <div className="absolute bottom-1 left-4">
          <Sparkle size={12} weight="fill" className="text-yellow-400" />
        </div>
      </div>
    </div>
  );
}

export default CouponCode;
